import React, { useEffect } from 'react';
import BuilderElementMask, {
    BuilderElementMaskProps,
} from '@form-engine/builder-mask/components/mask';
import BuilderMaskGroup from '@form-engine/builder-mask/components/mask/group';
import BuilderMaskGroupAppearance from '@form-engine/builder-mask/components/groups/appearance';
import BuilderLabelProperty from '@form-engine/builder-mask/components/properties/label';
import BuilderDataSourceProperty from '@form-engine/builder-mask/components/properties/data-source';
import BuilderMaskGroupValidation from '@form-engine/builder-mask/components/groups/validation';
import BuilderBooleanProperty from '@form-engine/builder-mask/components/properties/boolean';
import BuilderMaskGroupConditions from '@form-engine/builder-mask/components/groups/conditions';
import BuilderExpressionsProperty from '@form-engine/builder-mask/components/properties/expressions';
import { Element } from '.';
import { i18n } from '@form-engine/builder-application';
import { useMaskProperty } from '@form-engine/builder-mask/hooks/use-mask';
import BuilderStringProperty from '@form-engine/builder-mask/components/properties/string';
import {
    ElementDatasourceConfiguration,
    ExpressionDefinition,
} from '@form-engine/core-application/types/form';

export default function BuilderCheckboxElementMask(
    props: BuilderElementMaskProps
) {
    const { c } = i18n.prefix(`mask.${Element.apiName}.`);

    const [nested] = useMaskProperty('nested', false);

    const [datasource, setDatasource] = useMaskProperty<
        ElementDatasourceConfiguration | undefined
    >('datasource');

    const [datasourceExpressions, setDatasourceExpressions] = useMaskProperty<
        ExpressionDefinition[] | undefined
    >('datasourceExpressions');

    useEffect(() => {
        if (!nested) {
            return;
        }
        if (datasource?.mode !== 'source') {
            setDatasource({
                ...(datasource ?? {}),
                mode: 'source',
            });
        }
        if (datasourceExpressions) {
            setDatasourceExpressions(undefined);
        }
    }, [
        nested,
        datasource,
        setDatasource,
        datasourceExpressions,
        setDatasourceExpressions,
    ]);

    return (
        <BuilderElementMask id={Element.apiName} {...props}>
            <BuilderMaskGroupAppearance />
            <BuilderMaskGroup label={c('groupTitle')}>
                <BuilderLabelProperty />
                <BuilderBooleanProperty
                    propertyName="inline"
                    label={c('inline')}
                />
                <BuilderBooleanProperty
                    propertyName="nested"
                    label={c('nested')}
                />

                {nested ? (
                    <BuilderMaskGroup>
                        <BuilderStringProperty
                            propertyName="nestedGroupLabel"
                            compilable
                            variableOptions={['$i']}
                            defaultValue="{{$i.Label}}"
                            label={c('nestedGroupLabel')}
                        />
                        <BuilderStringProperty
                            propertyName="nestedGroupOptions"
                            defaultValue="Options"
                            label={c('nestedGroupOptions')}
                        />
                        <BuilderDataSourceProperty
                            label={c('datasource')}
                            modes={['source']}
                            stacked={false}
                        />
                    </BuilderMaskGroup>
                ) : (
                    <>
                        <BuilderDataSourceProperty label={c('datasource')} />
                        <BuilderExpressionsProperty
                            label={c('datasourceExpressions')}
                            propertyName="datasourceExpressions"
                            variableOptions={['$i.']}
                        />
                    </>
                )}
            </BuilderMaskGroup>
            <BuilderMaskGroupValidation />
            <BuilderMaskGroupConditions />
        </BuilderElementMask>
    );
}
